import {
  AppBar,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Slide,
  Toolbar,
  Avatar,
  ListSubheader,
  Typography,
  Box,
  IconButton,
  ListItemIcon,
  Dialog,
  DialogTitle,
  DialogContent,
  useMediaQuery,
  DialogActions,
  Button,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { ArrowBack, Settings, Help, Info } from "@material-ui/icons";
import React from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import AboutUs from "./AboutUs";
// import EditProfileForm from "./EditProfileForm";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function MobileSettingsPage() {
  const [checked, setchecked] = React.useState(false);
  const { currentUser } = useAuth();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [profileDialogOpen, setProfileDialog] = React.useState(false);
  const [aboutUsDialogOpen, setaboutUsDialog] = React.useState(false);

  const history = useHistory();
  const handleBackArrow = () => {
    setchecked(false);
    history.goBack();
  };

  React.useEffect(() => {
    setchecked(true);
  }, []);

  return (
    <Slide in={checked} direction="left" mountOnEnter unmountOnExit>
      <div>
        <AppBar position="fixed">
          <Toolbar>
            <IconButton
              style={{ color: "white" }}
              edge="start"
              onClick={handleBackArrow}
            >
              <ArrowBack />
            </IconButton>
            <Typography variant="h6">Settings</Typography>
          </Toolbar>
        </AppBar>
        <Box>
          <List>
            <ListSubheader>Profile</ListSubheader>
            <ListItem divider button>
              <ListItemAvatar>
                <Avatar
                  src={currentUser.photoURL}
                  alt={currentUser.displayName}
                >
                  {currentUser.displayName[0]}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={currentUser.displayName}
                secondary={currentUser.email}
              />
            </ListItem>
            <ListItem disabled button>
              <ListItemIcon>
                <Settings />
              </ListItemIcon>
              <ListItemText primary="Settings" />
            </ListItem>
            <ListItem disabled button>
              <ListItemIcon>
                <Help />
              </ListItemIcon>
              <ListItemText primary="Help" />
            </ListItem>
            <ListItem onClick={() => setaboutUsDialog(true)} button>
              <ListItemIcon>
                <Info />
              </ListItemIcon>
              <ListItemText primary="About Us" />
            </ListItem>
          </List>
        </Box>
        {/* <Dialog
          fullScreen={fullScreen}
          fullWidth={true}
          maxWidth="sm"
          open={profileDialogOpen}
          TransitionComponent={Transition}
        >
          <DialogTitle>
            {fullScreen ? (
              <AppBar>
                <Toolbar>
                  <IconButton
                    style={{ color: "white" }}
                    onClick={() => setProfileDialog(false)}
                  >
                    <ArrowBack />
                  </IconButton>
                  <Typography variant="h6">Edit Profile details</Typography>
                </Toolbar>
              </AppBar>
            ) : (
              "Edit Profile details"
            )}
          </DialogTitle>
          <DialogContent style={fullScreen ? { marginTop: 50 } : null}>
            <EditProfileForm />
          </DialogContent>
          {!fullScreen ? (
            <DialogActions>
              <Button variant="text" onClick={() => setProfileDialog(false)}>
                cancel
              </Button>
            </DialogActions>
          ) : (
            ""
          )}
        </Dialog> */}

        {/* about us dialog box */}
        <Dialog
          fullScreen={fullScreen}
          fullWidth={true}
          maxWidth="sm"
          open={aboutUsDialogOpen}
          TransitionComponent={Transition}
        >
          <DialogTitle>
            {fullScreen ? (
              <AppBar>
                <Toolbar>
                  <IconButton
                    style={{ color: "white" }}
                    onClick={() => setaboutUsDialog(false)}
                  >
                    <ArrowBack />
                  </IconButton>
                  <Typography variant="h6">About Us</Typography>
                </Toolbar>
              </AppBar>
            ) : (
              "About Us"
            )}
          </DialogTitle>
          <DialogContent style={fullScreen ? { marginTop: 50 } : null}>
            <AboutUs />
          </DialogContent>
          {!fullScreen ? (
            <DialogActions>
              <Button variant="text" onClick={() => setaboutUsDialog(false)}>
                cancel
              </Button>
            </DialogActions>
          ) : (
            ""
          )}
        </Dialog>
      </div>
    </Slide>
  );
}

export default MobileSettingsPage;
